import { persTestMok } from './mokData';
import {
    STATISTICS_DASHBOARD_SUCCESS
} from './constants';

const initialStstisticsDashBoardState = {
    ...persTestMok

};

/**
 *
 * @param state
 * @param action
 * @returns {{quiz, calendar, person, academy}}
 */
const ststisticsDashBoardReducer = ( state = initialStstisticsDashBoardState, action ) => {
    switch ( action.type ) {
        case STATISTICS_DASHBOARD_SUCCESS: {
            return { ...state, ...action.ststistics };
        }
        default:
            return state;
    }
};

export { ststisticsDashBoardReducer as dashboardstst };
